export { default } from './TinyDeliveryBanner';
